import PeopleAuthors from './PeopleAuthors';

export { type PeopleAuthorsProps } from './PeopleAuthors';
export default PeopleAuthors;
